/**
 * API: Billing / Plan del tenant activo (Sprint 17.1).
 */

import { request } from "./_client";

export interface QuotaUsageDTO {
  used: number;
  limit: number;
  remaining: number;
  is_exhausted: boolean;
  period_starts_at: string | null;
  period_resets_at: string | null;
}

export type TierName = "esencial" | "pro";
export type TierPeriod = "monthly" | "semestral" | "annual";

export interface PlanSummaryDTO {
  tier: TierName;
  period: TierPeriod | null;
  started_at: string | null;
  renews_at: string | null;
  ai_messages: QuotaUsageDTO;
  active_projects: QuotaUsageDTO;
  users: QuotaUsageDTO;
  includes_ai_assistant: boolean;
  includes_priority_support: boolean;
  sla_pct: number;
}

/** Resumen del plan del tenant activo + uso del mes (Sprint 17.1). */
export function fetchMyPlan(municipality: string): Promise<PlanSummaryDTO> {
  return request<PlanSummaryDTO>(
    `/billing/my-plan?municipality=${encodeURIComponent(municipality)}`,
  );
}
